'use client';

import * as React from 'react';
import { styled } from '@linaria/react';

import { range } from '@/utils';
import Demo from '@/components/Demo';

import GlowingPushButton from './GlowingPushButton';

function ButtonPushDemo() {
  const [selectedButton, setSelectedButton] = React.useState<
    number | null
  >(null);

  return (
    <Demo
      id="button-push-demo"
      initialValues={{}}
      outputWrapper={null}
    >
      {({}) => {
        return (
          <Wrapper>
            {range(4).map((value) => (
              <GlowingPushButton
                key={value}
                name="waveform"
                label="Example Button"
                width={64}
                height={64}
                checked={selectedButton === value}
                onChange={() => {
                  setSelectedButton(value);
                }}
              />
            ))}
          </Wrapper>
        );
      }}
    </Demo>
  );
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 16px;
`;

export default ButtonPushDemo;
